import { cmsCLient } from '@/services/axiosConfig'
import { GetSearchRes } from './types'

export type Search = (key: string) => Promise<GetSearchRes>

export const search: Search = async (key: string) => {
  try {
    const response = await cmsCLient.get('/search?q=' + key)
    return response.data
  } catch (e: any) {
    return e.message
  }
}
